import { Injectable } from '@angular/core';
import { RemainingTime } from './types/remaining-time';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  static convertMaskToRegEx(mask): RegExp {
    // strip out {, }, -
    let pattern = mask.replace(/[{}-]/g, '');
    // replace arrays [a, b, c] with regex options (a|b|c)
    pattern = pattern.replace(/\[/g, '(').replace(/]/g, ')').replace(/,/g, '|');
    // replace 'X' wildcards with regex \d (for digit)
    pattern = pattern.replace(/X/g, '\\d');
    // match exact digits
    pattern = '\\b' + pattern + '\\b';
    // Make it a RegExp pattern
    return new RegExp(pattern);
  }

  static remainingTime(timestamp: number): RemainingTime {
    return {
      days: Math.floor(timestamp / 86400000),
      hours: Math.floor((timestamp % 86400000) / 3600000),
      minutes: Math.round(((timestamp % 86400000) % 3600000) / 60000),
      seconds: Math.round((((timestamp % 86400000) % 3600000) % 60000) / 1000),
    };
  }

  static removeTitleMenu() {
    const el = document.getElementsByTagName('lp2-title-bar').item(0);

    if (el) {
      el.classList.add('d-none');
    }
  }
  static isNotNull<T>(value: T): value is NonNullable<T> {
    return value != null;
  }

  // Object.entries() method
  static objectEntries(obj: any): [string, any][] {
    const ownProps = Object.keys( obj );
    let i = ownProps.length;
    const resArray = new Array(i);
    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    }

    return resArray;
  }

  static objectValues(obj: any): any[] {
    const ownProps = Object.keys( obj );
    let i = ownProps.length;
    const resArray = new Array(i);
    while (i--) {
      resArray[i] = obj[ownProps[i]];
    }

    return resArray;
  }

  static createUrl(baseURL: string, params: Record<string, any> = {}) {
    return {
      get params() {
        return UtilsService.objectEntries(params)
          .map(([key, value]) => `${escape(key)}=${escape(value)}`)
          .join('&');
      },
      get href() {
        return `${baseURL}${this.params ? `?${this.params}` : ''}`;
      },
      setParams: (newParams: Record<string, any>) => {
        Object.assign(params, newParams);
      },
      setParam: (key: string, val: any) => {
        params[key] = val;
      },
      removeParam: (key: string) => {
        delete params[key];
      },
    };
  }

  static asciiNormalize(str: string) {
    if (typeof str !== "string") return str;
    let s = str.normalize("NFKD").replace(/[\u0300-\u036f]/g, '');

    const map = {
      "\u2018": "'", "\u2019": "'", "\u2032": "'", "\u02BC": "'", "\u2039": "'", "\u203A": "'",
      "\u201C": '"', "\u201D": '"', "\u2033": '"', "\u00AB": '"', "\u00BB": '"',
      "\u2010": "-", "\u2011": "-", "\u2012": "-", "\u2013": "-", "\u2014": "-", "\u2015": "-", "\u2212": "-",
      "\u2026": "...",
      "\u2022": "*", "\u00B7": "*",
      "\u00D7": "x", "\u00F7": "/", "\u2044": "/", "\u00B0": " deg ", "\u00B5": "u",
      "\u00A0": " ", "\u202F": " ", "\u2009": " ", "\u200A": " ",
      "\u200B": "", "\u200C": "", "\u200D": "", "\uFEFF": ""
    };

    s = s.replace(
      /[\u2018\u2019\u2032\u02BC\u2039\u203A\u201C\u201D\u2033\u00AB\u00BB\u2010\u2011\u2012\u2013\u2014\u2015\u2212\u2026\u2022\u00B7\u00D7\u00F7\u2044\u00B0\u00B5\u00A0\u202F\u2009\u200A\u200B\u200C\u200D\uFEFF]/g,
      c => map[c]
    );

    s = s.replace(/[\u0000-\u001F\u007F]/g, "").replace(/\s+/g, " ").trim();

    return s.replace(/[^\x20-\x7E]/g, "");
  }

}



// WEBPACK FOOTER //
// ./ts/app/shared/utils.service.ts